import { NO_EPG_ID } from '../index.h'

export { inRange, rangeCovered, rangePosition } from './ranges'
export { getMapKeyForProgram } from './upcoming'

// `epgId` getter
export const epgId = <T extends { epgId?: string }>(obj: T): string =>
  obj.epgId ?? NO_EPG_ID
